import { render, staticRenderFns } from "./MarkLbl.vue?vue&type=template&id=73f84e41&scoped=true"
import script from "./MarkLbl.vue?vue&type=script&lang=js"
export * from "./MarkLbl.vue?vue&type=script&lang=js"
import style0 from "./MarkLbl.vue?vue&type=style&index=0&id=73f84e41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f84e41",
  null
  
)

export default component.exports